import { useEffect } from "react";

import { Label, Input, Checkbox, Select, ColorPicker } from "neetoui";
import { useTranslation } from "react-i18next";

import { FLOATING_BUTTON_POSITIONS } from "./constants";
import DynamicQueryParams from "./DynamicQueryParams";

import useProductEmbedStore from "../useProductEmbedStore";

const FloatingPopup = ({
  customization,
  updateCustomization,
  otherCustomizations,
}) => {
  const { t } = useTranslation();
  const { isQueryParamsEnabled } = useProductEmbedStore.pick();

  const { btnTextColor, showIcon, btnText, btnPosition, btnColor, icon } =
    customization;

  useEffect(() => {
    if (isQueryParamsEnabled) return;

    updateCustomization({ queryParams: undefined });
  }, []);

  return (
    <div className="flex w-full flex-col gap-y-4">
      <div className="flex flex-col gap-y-2">
        <Input
          data-testid="button-text-input-field"
          label={t("neetoMolecules.productEmbed.floatingPopup.button.text")}
          value={btnText}
          error={
            !btnText &&
            t("neetoMolecules.productEmbed.floatingPopup.button.textError")
          }
          onChange={e => updateCustomization({ btnText: e.target.value })}
        />
      </div>
      <div className="flex flex-col gap-y-2">
        <Select
          data-testid="button-position-select-field"
          label={t("neetoMolecules.productEmbed.floatingPopup.button.pos")}
          options={FLOATING_BUTTON_POSITIONS}
          value={btnPosition}
          getOptionValue={option =>
            typeof option === "string" ? option : option.value
          }
          onChange={e => updateCustomization({ btnPosition: e.value })}
        />
      </div>
      <div
        className="flex items-center justify-between gap-2"
        data-testid="button-color-label"
      >
        <Label>
          {t("neetoMolecules.productEmbed.floatingPopup.button.color")}
        </Label>
        <ColorPicker
          color={btnColor}
          size="medium"
          onChange={e => updateCustomization({ btnColor: e.hex })}
        />
      </div>
      <div
        className="flex items-center justify-between gap-2"
        data-testid="button-text-color-label"
      >
        <Label>
          {t("neetoMolecules.productEmbed.floatingPopup.button.textColor")}
        </Label>
        <ColorPicker
          color={btnTextColor}
          size="medium"
          onChange={e => updateCustomization({ btnTextColor: e.hex })}
        />
      </div>
      {icon && (
        <Checkbox
          checked={showIcon}
          data-testid="show-icon-checkbox"
          label={t("neetoMolecules.productEmbed.floatingPopup.showCalIcon")}
          onChange={e => updateCustomization({ showIcon: e.target.checked })}
        />
      )}
      {otherCustomizations()}
      {isQueryParamsEnabled && (
        <DynamicQueryParams {...{ updateCustomization }} />
      )}
    </div>
  );
};

export default FloatingPopup;
